<mapfre-header></mapfre-header>
<div class="container mapfre-content" [ngClass]="{ 'not-logged-page': !isAcmic }">
<mapfre-card 
  additionalClasses="forgot-password">

  <ng-container *ngIf="!showConfirmationBox && !tooManyAttempts">
    <div class="row text-center margin-bottom mb24">
      <div class="col"> 
        <ng-container *ngIf="isAcmic">
        <div class="header-icon full-icon">
            <figure>
                <img src="./assets/img/images/profile.svg" alt="Forgot Password" />
            </figure>
        </div>
      </ng-container>

        <h1 class="title-copy" [ngClass]="{ 'font-weight-normal': !isAcmic }">{{ 'FORGOT_PASSWORD_TITLE' | translate }}</h1> 
        <div class="brand-lite-blue">{{ 'FORGOT_PASSWORD_PARAGRAPH' | translate }}</div>
      </div>
    </div>
    <mapfre-alert></mapfre-alert>
    <app-send-email-form  
      [inputs]="emailInputs"
      [emailPrefillParamater]="emailPrefillParamater"
      (showConfirmation)="showConfirmationAction($event)">
    </app-send-email-form>
  </ng-container>
  
  <ng-container *ngIf="showConfirmationBox"> 
    <div class="row text-center">
      <div class="col"> 
        <div class="header-icon full-icon">
          <ng-container *ngIf="isAcmic; else otherState">
            <figure>
              <img src="./assets/img/images/email.svg" alt="Email" />
            </figure>
          </ng-container>
          <ng-template #otherState>
            <figure>
              <img src="./assets/img/images/email.svg" alt="Email" />
            </figure>
          </ng-template>
        </div>
        <h1 class="title-copy" [ngClass]="{ 'font-weight-normal': !isAcmic }">{{ 'CHECK_YOUR_EMAIL_TITLE' | translate }}</h1> 
        <div class="grey-color maxWidthPara" [ngClass]="{'title-width':!isAcmic}">{{ 'CHECK_YOUR_EMAIL_PARAGRAPH' | translate }}</div>
        <div [ngClass]="{'mt-16 fs-14':isAcmic, 'font-medium':!isAcmic}"><strong>{{ emailPrefillParamater }}</strong></div>
      </div>
    </div>
    <app-email-confirmation 
      (showConfirmation)="showConfirmationAction($event)"
      [sendEmailAgain]="emailPrefillParamater">
    </app-email-confirmation>
  </ng-container>

  <ng-container *ngIf="tooManyAttempts">
    <div class="row text-center">
      <div class="col">
        <div class="header-icon"> 
          <svg-too-many-attempts-svg></svg-too-many-attempts-svg>
        </div>
        <h1 class="title-copy grey-color">{{ 'TOO_MANY_ATTEMPTS_TITLE' | translate }}</h1> 
      </div>
    </div>
    <app-forgot-password-too-many-attempts></app-forgot-password-too-many-attempts>
  </ng-container>
</mapfre-card>
</div>